import {Col} from "react-bootstrap";

function Credits() {
    return (
        <Col lg={12} className="px-0">
            <p >
                Creators: Theodorus Fransen, Giovanni Moretti, Paolo Ruffolo
                Contributors: Theodorus Fransen, Giovanni Moretti, Paolo Ruffolo, Federico Simone Samperi

            </p>
            <p>The MOLOR project was funded by the European Union as part of its Horizon Europe scientific research
                initiative under the Marie Skłodowska-Curie Actions (MSCA), grant agreement no. 101106220.
            </p>
        </Col>
    );
}

export default Credits;

